export var EResult;
(function (EResult) {
    EResult[EResult["OK"] = 1] = "OK";
    EResult[EResult["Fail"] = 2] = "Fail";
    EResult[EResult["NoConnection"] = 3] = "NoConnection";
    EResult[EResult["InvalidPassword"] = 5] = "InvalidPassword";
    EResult[EResult["LoggedInElsewhere"] = 6] = "LoggedInElsewhere";
    EResult[EResult["InvalidProtocolVer"] = 7] = "InvalidProtocolVer";
    EResult[EResult["InvalidParam"] = 8] = "InvalidParam";
    EResult[EResult["FileNotFound"] = 9] = "FileNotFound";
    EResult[EResult["Busy"] = 10] = "Busy";
    EResult[EResult["InvalidState"] = 11] = "InvalidState";
    EResult[EResult["InvalidName"] = 12] = "InvalidName";
    EResult[EResult["InvalidEmail"] = 13] = "InvalidEmail";
    EResult[EResult["DuplicateName"] = 14] = "DuplicateName";
    EResult[EResult["AccessDenied"] = 15] = "AccessDenied";
    EResult[EResult["Timeout"] = 16] = "Timeout";
    EResult[EResult["Banned"] = 17] = "Banned";
    EResult[EResult["AccountNotFound"] = 18] = "AccountNotFound";
    EResult[EResult["InvalidSteamID"] = 19] = "InvalidSteamID";
    EResult[EResult["ServiceUnavailable"] = 20] = "ServiceUnavailable";
    EResult[EResult["NotLoggedOn"] = 21] = "NotLoggedOn";
    EResult[EResult["Pending"] = 22] = "Pending";
    EResult[EResult["EncryptionFailure"] = 23] = "EncryptionFailure";
    EResult[EResult["InsufficientPrivilege"] = 24] = "InsufficientPrivilege";
    EResult[EResult["LimitExceeded"] = 25] = "LimitExceeded";
    EResult[EResult["Revoked"] = 26] = "Revoked";
    EResult[EResult["Expired"] = 27] = "Expired";
    EResult[EResult["AlreadyRedeemed"] = 28] = "AlreadyRedeemed";
    EResult[EResult["DuplicateRequest"] = 29] = "DuplicateRequest";
    EResult[EResult["AlreadyOwned"] = 30] = "AlreadyOwned";
    EResult[EResult["IPNotFound"] = 31] = "IPNotFound";
    EResult[EResult["PersistFailed"] = 32] = "PersistFailed";
    EResult[EResult["LockingFailed"] = 33] = "LockingFailed";
    EResult[EResult["LogonSessionReplaced"] = 34] = "LogonSessionReplaced";
    EResult[EResult["ConnectFailed"] = 35] = "ConnectFailed";
    EResult[EResult["HandshakeFailed"] = 36] = "HandshakeFailed";
    EResult[EResult["IOFailure"] = 37] = "IOFailure";
    EResult[EResult["RemoteDisconnect"] = 38] = "RemoteDisconnect";
    EResult[EResult["ShoppingCartNotFound"] = 39] = "ShoppingCartNotFound";
    EResult[EResult["Blocked"] = 40] = "Blocked";
    EResult[EResult["Ignored"] = 41] = "Ignored";
    EResult[EResult["NoMatch"] = 42] = "NoMatch";
    EResult[EResult["AccountDisabled"] = 43] = "AccountDisabled";
    EResult[EResult["ServiceReadOnly"] = 44] = "ServiceReadOnly";
    EResult[EResult["AccountNotFeatured"] = 45] = "AccountNotFeatured";
    EResult[EResult["AdministratorOK"] = 46] = "AdministratorOK";
    EResult[EResult["ContentVersion"] = 47] = "ContentVersion";
    EResult[EResult["TryAnotherCM"] = 48] = "TryAnotherCM";
    EResult[EResult["PasswordRequiredToKickSession"] = 49] = "PasswordRequiredToKickSession";
    EResult[EResult["AlreadyLoggedInElsewhere"] = 50] = "AlreadyLoggedInElsewhere";
    EResult[EResult["Suspended"] = 51] = "Suspended";
    EResult[EResult["Cancelled"] = 52] = "Cancelled";
    EResult[EResult["DataCorruption"] = 53] = "DataCorruption";
    EResult[EResult["DiskFull"] = 54] = "DiskFull";
    EResult[EResult["RemoteCallFailed"] = 55] = "RemoteCallFailed";
    EResult[EResult["PasswordUnset"] = 56] = "PasswordUnset";
    EResult[EResult["ExternalAccountUnlinked"] = 57] = "ExternalAccountUnlinked";
    EResult[EResult["PSNTicketInvalid"] = 58] = "PSNTicketInvalid";
    EResult[EResult["ExternalAccountAlreadyLinked"] = 59] = "ExternalAccountAlreadyLinked";
    EResult[EResult["RemoteFileConflict"] = 60] = "RemoteFileConflict";
    EResult[EResult["IllegalPassword"] = 61] = "IllegalPassword";
    EResult[EResult["SameAsPreviousValue"] = 62] = "SameAsPreviousValue";
    EResult[EResult["AccountLogonDenied"] = 63] = "AccountLogonDenied";
    EResult[EResult["CannotUseOldPassword"] = 64] = "CannotUseOldPassword";
    EResult[EResult["InvalidLoginAuthCode"] = 65] = "InvalidLoginAuthCode";
    EResult[EResult["AccountLogonDeniedNoMail"] = 66] = "AccountLogonDeniedNoMail";
    EResult[EResult["HardwareNotCapableOfIPT"] = 67] = "HardwareNotCapableOfIPT";
    EResult[EResult["IPTInitError"] = 68] = "IPTInitError";
    EResult[EResult["ParentalControlRestricted"] = 69] = "ParentalControlRestricted";
    EResult[EResult["FacebookQueryError"] = 70] = "FacebookQueryError";
    EResult[EResult["ExpiredLoginAuthCode"] = 71] = "ExpiredLoginAuthCode";
    EResult[EResult["IPLoginRestrictionFailed"] = 72] = "IPLoginRestrictionFailed";
    EResult[EResult["AccountLockedDown"] = 73] = "AccountLockedDown";
    EResult[EResult["AccountLogonDeniedVerifiedEmailRequired"] = 74] = "AccountLogonDeniedVerifiedEmailRequired";
    EResult[EResult["NoMatchingURL"] = 75] = "NoMatchingURL";
    EResult[EResult["BadResponse"] = 76] = "BadResponse";
    EResult[EResult["RequirePasswordReEntry"] = 77] = "RequirePasswordReEntry";
    EResult[EResult["ValueOutOfRange"] = 78] = "ValueOutOfRange";
    EResult[EResult["UnexpectedError"] = 79] = "UnexpectedError";
    EResult[EResult["Disabled"] = 80] = "Disabled";
    EResult[EResult["InvalidCEGSubmission"] = 81] = "InvalidCEGSubmission";
    EResult[EResult["RestrictedDevice"] = 82] = "RestrictedDevice";
    EResult[EResult["RegionLocked"] = 83] = "RegionLocked";
    EResult[EResult["RateLimitExceeded"] = 84] = "RateLimitExceeded";
    EResult[EResult["AccountLoginDeniedNeedTwoFactor"] = 85] = "AccountLoginDeniedNeedTwoFactor";
    EResult[EResult["ItemDeleted"] = 86] = "ItemDeleted";
    EResult[EResult["AccountLoginDeniedThrottle"] = 87] = "AccountLoginDeniedThrottle";
    EResult[EResult["TwoFactorCodeMismatch"] = 88] = "TwoFactorCodeMismatch";
    EResult[EResult["TwoFactorActivationCodeMismatch"] = 89] = "TwoFactorActivationCodeMismatch";
    EResult[EResult["AccountAssociatedToMultiplePartners"] = 90] = "AccountAssociatedToMultiplePartners";
    EResult[EResult["NotModified"] = 91] = "NotModified";
    EResult[EResult["NoMobileDevice"] = 92] = "NoMobileDevice";
    EResult[EResult["TimeNotSynced"] = 93] = "TimeNotSynced";
    EResult[EResult["SmsCodeFailed"] = 94] = "SmsCodeFailed";
    EResult[EResult["AccountLimitExceeded"] = 95] = "AccountLimitExceeded";
    EResult[EResult["AccountActivityLimitExceeded"] = 96] = "AccountActivityLimitExceeded";
    EResult[EResult["PhoneActivityLimitExceeded"] = 97] = "PhoneActivityLimitExceeded";
    EResult[EResult["RefundToWallet"] = 98] = "RefundToWallet";
    EResult[EResult["EmailSendFailure"] = 99] = "EmailSendFailure";
    EResult[EResult["NotSettled"] = 100] = "NotSettled";
    EResult[EResult["NeedCaptcha"] = 101] = "NeedCaptcha";
    EResult[EResult["GSLTDenied"] = 102] = "GSLTDenied";
    EResult[EResult["GSOwnerDenied"] = 103] = "GSOwnerDenied";
    EResult[EResult["InvalidItemType"] = 104] = "InvalidItemType";
    EResult[EResult["IPBanned"] = 105] = "IPBanned";
    EResult[EResult["GSLTExpired"] = 106] = "GSLTExpired";
    EResult[EResult["InsufficientFunds"] = 107] = "InsufficientFunds";
    EResult[EResult["TooManyPending"] = 108] = "TooManyPending";
    EResult[EResult["NoSiteLicensesFound"] = 109] = "NoSiteLicensesFound";
    EResult[EResult["WGNetworkSendExceeded"] = 110] = "WGNetworkSendExceeded";
    EResult[EResult["AccountNotFriends"] = 111] = "AccountNotFriends";
    EResult[EResult["LimitedUserAccount"] = 112] = "LimitedUserAccount";
})(EResult || (EResult = {}));
export var EBrowserType;
(function (EBrowserType) {
    /**
     * No window is created (like SharedJSContext).
     */
    EBrowserType[EBrowserType["OffScreen"] = 0] = "OffScreen";
    EBrowserType[EBrowserType["OpenVROverlay"] = 1] = "OpenVROverlay";
    EBrowserType[EBrowserType["OpenVROverlay_Dashboard"] = 2] = "OpenVROverlay_Dashboard";
    /**
     * A normal window.
     */
    EBrowserType[EBrowserType["DirectHWND"] = 3] = "DirectHWND";
    /**
     * A borderless window.
     */
    EBrowserType[EBrowserType["DirectHWND_Borderless"] = 4] = "DirectHWND_Borderless";
    /**
     * An initially hidden window.
     * May be shown with {@link SteamClient.Window.ShowWindow}.
     */
    EBrowserType[EBrowserType["DirectHWND_Hidden"] = 5] = "DirectHWND_Hidden";
    EBrowserType[EBrowserType["ChildHWNDNative"] = 6] = "ChildHWNDNative";
    EBrowserType[EBrowserType["Offscreen_SteamUI"] = 12] = "Offscreen_SteamUI";
    EBrowserType[EBrowserType["OpenVROverlay_Subview"] = 13] = "OpenVROverlay_Subview";
})(EBrowserType || (EBrowserType = {}));
export var ESteamRealm;
(function (ESteamRealm) {
    ESteamRealm[ESteamRealm["Unknown"] = 0] = "Unknown";
    ESteamRealm[ESteamRealm["Global"] = 1] = "Global";
    ESteamRealm[ESteamRealm["China"] = 2] = "China";
})(ESteamRealm || (ESteamRealm = {}));
/**
 * Controls how Gamescope renders the GamepadUI window when a game is running.
 */
export var EUIComposition;
(function (EUIComposition) {
    /** Steam is not rendered on the screen. */
    EUIComposition[EUIComposition["Hidden"] = 0] = "Hidden";
    /**
     * Transparent divs will allow pixels from the app behind Steam to penetrate.
     * Input goes to **the app**.
     */
    EUIComposition[EUIComposition["Notification"] = 1] = "Notification";
    /**
     * Transparent divs will allow pixels from the app behind Steam to penetrate.
     * Input goes to **Steam**.
     */
    EUIComposition[EUIComposition["Overlay"] = 2] = "Overlay";
    /** Take all of the pixels on the screen, nothing "behind" Steam is shown. */
    EUIComposition[EUIComposition["Opaque"] = 3] = "Opaque";
    /**
     * Special composition mode that matches {@link Overlay}, but forwards synthetic keyboard
     * events to the Gamescope foreground app (game) instead of Steam.
     */
    EUIComposition[EUIComposition["OverlayKeyboard"] = 4] = "OverlayKeyboard";
})(EUIComposition || (EUIComposition = {}));
export var EUIMode;
(function (EUIMode) {
    EUIMode[EUIMode["Unknown"] = -1] = "Unknown";
    EUIMode[EUIMode["GamePad"] = 4] = "GamePad";
    EUIMode[EUIMode["Desktop"] = 7] = "Desktop";
})(EUIMode || (EUIMode = {}));
